<template>
  <u-dropdown
    v-if="clip"
    v-model:open="isOpen"
    :items="menuItems"
    :popper="resolvedPopper"
    :class="{ dark: context }"
    :style="rootStyle"
    @click.stop
  >
    <slot>
      <span
        tabindex="-1"
        aria-hidden="true"
        class="block h-px w-px opacity-0 pointer-events-none"
      />
    </slot>
  </u-dropdown>
</template>

<script setup>
  const props = defineProps({
    clip: {
      type: Object,
      default: null
    },
    context: Boolean,
    popper: {
      type: Object,
      default: () => ({})
    }
  });

  const {getClipMenuItems} = useVideoEditorClipActionsMenu();

  const defaultPopper = {
    placement: 'bottom-end'
  };

  const isOpen = ref(false);
  const contextAnchor = ref({
    x: 0,
    y: 0
  });

  const menuItems = computed(() => {
    if (!props.clip) {
      return [];
    }

    return getClipMenuItems(props.clip);
  });

  const resolvedPopper = computed(() => ({
    ...defaultPopper,
    ...props.popper
  }));

  const rootStyle = computed(() => {
    if (!props.context) {
      return undefined;
    }

    return {
      position: 'fixed',
      left: `${contextAnchor.value.x}px`,
      top: `${contextAnchor.value.y}px`,
      width: '1px',
      height: '1px',
      zIndex: 60
    };
  });

  async function open({clientX, clientY} = {}) {
    if (Number.isFinite(clientX)) {
      contextAnchor.value.x = clientX;
    }

    if (Number.isFinite(clientY)) {
      contextAnchor.value.y = clientY;
    }

    isOpen.value = false;
    await nextTick();
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  defineExpose({
    open,
    close
  });
</script>
